import { Sun, Baby, BookHeart, Utensils, Users } from "lucide-react";

const services = [
  {
    icon: Sun,
    title: "Daytime Support",
    desc: "Calm, capable presence during the day. Light tidying, baby holding, errands and emotional check-ins.",
  },
  {
    icon: BookHeart,
    title: "Lactation & Feeding",
    desc: "Latch help, pumping plans, paced bottle feeding, and gentle troubleshooting — formula or breast, no judgment.",
  },
  {
    icon: Baby,
    title: "Newborn Care Education",
    desc: "Soothing techniques, sleep rhythms, diapering, bathing — confidence-building guidance at your pace.",
  },
  {
    icon: Utensils,
    title: "Meal Prep & Household",
    desc: "Postpartum-nourishing meals, grocery runs, dish washing, laundry — so your home feels like a soft place to land.",
  },
  {
    icon: Users,
    title: "Sibling Support",
    desc: "Tender attention for older siblings as your family grows — books, gentle play, and easing transitions.",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32"
      style={{ background: "var(--bg-primary)" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl">
          <span className="section-eyebrow">Our Services</span>
          <span className="gold-divider ml-3 mb-2 align-middle" />
          <h2
            className="font-serif-display mt-4 text-4xl md:text-5xl lg:text-6xl leading-[1.05]"
            style={{ color: "var(--text-main)" }}
            data-testid="services-headline"
          >
            Care, woven around your family.
          </h2>
          <p className="mt-5 max-w-xl leading-relaxed" style={{ color: "var(--text-muted)" }}>
            Every package is shaped to your needs. Mix and match, or start with a free consultation to find
            the rhythm that fits.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-14">
          {services.map((s, i) => (
            <div
              key={s.title}
              className="brand-card p-8 group"
              data-testid={`service-card-${i}`}
            >
              <div
                className="w-12 h-12 rounded-full flex items-center justify-center mb-5 transition-colors"
                style={{ background: "var(--bg-secondary)" }}
              >
                <s.icon size={22} color="var(--blush-hover)" />
              </div>
              <h3 className="font-serif-display text-2xl mb-3" style={{ color: "var(--text-main)" }}>
                {s.title}
              </h3>
              <p className="text-sm leading-relaxed" style={{ color: "var(--text-muted)" }}>
                {s.desc}
              </p>
              <div
                className="mt-6 h-px w-10 transition-all duration-500 group-hover:w-20"
                style={{ background: "var(--gold)" }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
